import {processSolrPrograms} from '@nl/neu';
import {
	GET_RECOMMENDED, GET_RECOMMENDED_START, RESET_RECOMMENDED,
} from '../constants';

const getRecommendedAction = (programs, pageNumber, paging) => (
		{
			type: GET_RECOMMENDED,
			programs,
			pageNumber,
			paging,
		}
);

const resetRecommendedAction = () => (
		{
			type: RESET_RECOMMENDED,
		}
);

const getFavTeamProgramsPaging = (psPaging, pageSize) => {
	const paging = {};
	paging.pageSize = pageSize;
	paging.totalCount = psPaging.count;
	paging.totalPages = psPaging.totalPage;
	paging.hasNextPage = psPaging.totalPage > psPaging.pageNumber;
	return paging;
};

export const getRecommended = (pageNumber = 1, callback) => (dispatch, getState) => {
	const {config: {data: {PROGRAM_PAGE_SIZE}}} = getState();
	dispatch({type: GET_RECOMMENDED_START, pageNumber});
	window.ps.getRecommendedPrograms(null, {
		ps: PROGRAM_PAGE_SIZE,
		pn: pageNumber,
	}, (data, recommendListID, paging) => {
		dispatch(getRecommendedAction(processSolrPrograms(data.response.docs), pageNumber,
				getFavTeamProgramsPaging(paging, PROGRAM_PAGE_SIZE)));
		callback && callback(data.response && data.response.docs, paging);
	}, {
		fl: 'sequence,pid,name,description,seoName,runtime,releaseDate,releaseDateLocal,beginDateTime,beginDateTimeLocal,purchaseTypeId,showTitle,seasonTitle,image,programCode,extUrl,episode,location,venue,eventId,tvRating,progType,masterImage,catId,catSEOName,cat',
	});
};

export const resetRecommended = () => (dispatch) => {
	dispatch(resetRecommendedAction());
};
